import { BooleanSearchAndFilterBondParams } from './type';

export const currencyFilters: BooleanSearchAndFilterBondParams[] = ['eur', 'usd', 'foreignCurrencies'];

export const isCurrencyFilter = (field: BooleanSearchAndFilterBondParams): field is 'eur' |'usd' | 'foreignCurrencies' => currencyFilters.includes(field);
